module.exports = __webpack_public_path__ + "static/people_img6@2x-7e725bfdaf47a3b15192352a2cdc7c2f.png";